export const Contacts = axios => ({

  update(slug, payload) {
    return axios.put(`/v1/profiles/${slug}/contacts`, JSON.parse(JSON.stringify(payload)))
  },

  get(slug) {
    return axios.get(`/v1/profiles/${slug}/contacts`)
  },

  validateEmail(slug, email) {
    return axios.patch(`/v1/profiles/${slug}/contacts/email/check`, { email })
  },

  short(slug) {
    return axios.get(`/v1/profiles/${slug}/contacts/short`)
  }
})
